<template>
  <div class="content" v-if="route.name == 'Beranda'">
    <Beranda/>
  </div>
  <div class="content" v-if="route.name == 'DaftarKonten'">
    <DaftarKonten/>
  </div>
  <div class="content" v-if="route.name == 'DaftarBerita'">
    <DaftarBerita/>
  </div>
  <div class="content" v-if="route.name == 'ListBerita'">
    <ListBerita/>
  </div>
  <div class="content" v-if="route.name == 'Dashboard'">
    <Dashboard/>
  </div>
  <div class="content" v-if="route.name == 'InfoBeranda'">
    <InfoBeranda/>
  </div>
  <div class="content" v-if="route.name == 'ProsesInfoBeranda'">
    <ProsesInfoBeranda/>
  </div>
  <div class="content" v-if="route.name == 'Konten'">
    <Konten/>
  </div>
  <div class="content" v-if="route.name == 'ProsesKonten'">
    <ProsesKonten/>
  </div>
  <div class="content" v-if="route.name == 'Berita'">
    <Berita/>
  </div>
  <div class="content" v-if="route.name == 'ProsesBerita'">
    <ProsesBerita/>
  </div>
  <div class="content" v-if="route.name == 'User'">
    <User/>
  </div>
  <div class="content" v-if="route.name == 'ProsesUser'">
    <ProsesUser/>
  </div>
  <div class="content" v-if="route.name == 'Slider'">
    <Slider/>
  </div>
  <div class="content" v-if="route.name == 'ProsesSlider'">
    <ProsesSlider/>
  </div>
  <div class="content" v-if="route.name == 'SettingMenu'">
    <SettingMenu/>
  </div>
</template>

<script>
import Beranda from './components/views/Publik/Beranda.vue';
import DaftarKonten from './components/views/Publik/DaftarKonten.vue';
import DaftarBerita from './components/views/Publik/DaftarBerita.vue';
import ListBerita from './components/views/Publik/ListBerita.vue';
import Dashboard from './components/views/Dashboard/Dashboard.vue';
import InfoBeranda from './components/views/Backoffice/InfoBeranda/InfoBeranda.vue';
import ProsesInfoBeranda from './components/views/Backoffice/InfoBeranda/ProsesInfoBeranda.vue';
import Konten from './components/views/Backoffice/Konten/Konten.vue';
import ProsesKonten from './components/views/Backoffice/Konten/ProsesKonten.vue';
import Berita from './components/views/Backoffice/Berita/Berita.vue';
import ProsesBerita from './components/views/Backoffice/Berita/ProsesBerita.vue';
import User from './components/views/Backoffice/User/User.vue';
import ProsesUser from './components/views/Backoffice/User/ProsesUser.vue';
import Slider from './components/views/Backoffice/Slider/Slider.vue';
import ProsesSlider from './components/views/Backoffice/Slider/ProsesSlider.vue';
import SettingMenu from './components/views/Backoffice/SettingMenu/SettingMenu.vue';

import { useRoute } from 'vue-router';
import { watch } from 'vue';

export default {
  name: 'App',
  components: {
    Beranda,DaftarKonten,DaftarBerita,ListBerita,Dashboard,InfoBeranda,ProsesInfoBeranda,Konten
    ,ProsesKonten,Berita,ProsesBerita,User,ProsesUser,Slider,ProsesSlider,SettingMenu
  },
  mounted() {
    document.title = "SIBERBI - SIMULASI BERUSAHA BANGUN INVESTASI";
  },
  setup() {
    const route = useRoute()
    watch(() => route.name, () => {
    });

    return { route };
  }
}
</script>

<style></style>
